import { render, staticRenderFns } from "./giftPromo.vue?vue&type=template&id=0d40de8c&scoped=true"
import script from "./giftPromo.vue?vue&type=script&lang=js"
export * from "./giftPromo.vue?vue&type=script&lang=js"
import style0 from "./giftPromo.vue?vue&type=style&index=0&id=0d40de8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40de8c",
  null
  
)

export default component.exports